var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiptCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.834 2C20.223 2 22.5 4.378 22.5 7.916V16.084C22.5 19.622 20.223 22 16.833 22H8.165C4.776 22 2.5 19.622 2.5 16.084V7.916C2.5 4.378 4.776 2 8.165 2H16.834ZM16.834 3.5H8.165C5.635 3.5 4 5.233 4 7.916V16.084C4 18.767 5.635 20.5 8.165 20.5H16.833C19.364 20.5 21 18.767 21 16.084V7.916C21 5.233 19.364 3.5 16.834 3.5ZM16.5895 9.097C16.8825 9.39 16.8825 9.864 16.5895 10.157L11.8435 14.903C11.6975 15.05 11.5055 15.123 11.3135 15.123C11.1225 15.123 10.9295 15.05 10.7835 14.903L8.4095 12.53C8.1165 12.237 8.1165 11.763 8.4095 11.47C8.7025 11.177 9.1765 11.177 9.4695 11.47L11.3135 13.312L15.5295 9.097C15.8225 8.804 16.2965 8.804 16.5895 9.097Z",
    fill: "#4546F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptCheck);
export default __webpack_public_path__ + "static/media/receiptCheck.01d0fc952519692519c861b879f4f842.svg";
export { ForwardRef as ReactComponent };